// extracted by mini-css-extract-plugin
export var base1Slider = "style-module--base1Slider--c4e4b";
export var base2Slider = "style-module--base2Slider--1ffdc";
export var reconCustomDotSlider = "style-module--reconCustomDotSlider--196c5";
export var sixConfig = "style-module--sixConfig--5ad54";